import { ref } from 'vue';

import { useNotify } from '@/app/providers/notify';
import { useModalHandler } from '@/plugins/modal';
import { useSentry } from '@/plugins/sentry';
import { getErrorMessageTyped } from '@/shared/services';

import { submitRequest } from '../api';

import { useClosedSalesStore } from './store';

import type { cancelTypes } from './types';
import type { Ref } from 'vue';

interface ClosedSalesActions {
  isLoading: Ref<boolean>;
  handlerSendClosedSales: () => Promise<void>;
  handlerOpenModalClosedSales: (type: cancelTypes) => void;
}

export function useClosedSalesActions (): ClosedSalesActions {
  const notify = useNotify();
  const $modal = useModalHandler();
  const { handlerCheckStatus } = useClosedSalesStore();

  const isLoading = ref<boolean>(false);

  async function handlerSendClosedSales (): Promise<void> {
    try {
      isLoading.value = true;
      await submitRequest();
    } catch (error) {
      console.error('🚀 ~ file: useClosedSalesActions.ts ~ handlerSendClosedSales ~ error', error);
      useSentry().captureException(error);
      notify.create({
        type: 'negative',
        message: getErrorMessageTyped(error),
      });
    } finally {
      await handlerCheckStatus();
      isLoading.value = false;
    }
  }

  function handlerOpenModalClosedSales (type: cancelTypes): void {
    $modal.open({
      component: 'ModalClosedSalesRequest',
      overlay: false,
      transition: null,
      attrs: {
        type,
      },
    });
  }

  return {
    isLoading,
    handlerSendClosedSales,
    handlerOpenModalClosedSales,
  };
}
